<template>
  <v-card tile>
    <v-btn v-if="isAdmin" color="primary" dark class="ma-2" @click="$router.push('/students/create')">
      Inscrire un nouvel élève
    </v-btn>
    <v-card-title>
      Étudiants {{ this.filteredStudents.length }}
      <v-switch v-model="isShowAllStudents" :label="`Tout`" class="mx-5"></v-switch>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Chercher" single-line hide-details></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="filteredStudents"
      :loading="loading"
      no-data-text="'Aucun resultat trouvé'"
      :items-per-page="200"
      :search="search"
      :footer-props="{
        itemsPerPageText: 'Nombre de lignes',
        pageText: 'Lignes {0}-{1} de {2}',
      }"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.id" @click="navigateToStudent(item)" class="clickable">
            <td>{{ item.displayName }}</td>
            <td>{{ item.courses?.[0]?.name }}</td>
            <td>
              <v-tooltip bottom v-if="item.courses?.[0]?.type">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    small
                    :color="getCourseTypeColor(item.courses[0].type)"
                    text-color="white"
                    label
                    v-bind="attrs"
                    v-on="on"
                  >
                    <template v-if="item.courses[0].type === 'frdistance'">
                      FR
                      <v-icon small right>mdi-webcam</v-icon>
                    </template>
                    <template v-else>
                      {{ getCourseTypeAbbr(item.courses[0].type) }}
                    </template>
                  </v-chip>
                </template>
                <span>{{ getCourseTypeLabel(item.courses[0].type) }}</span>
              </v-tooltip>
            </td>
            <td>{{ item?.assistant?.name }}</td>
            <td>
              <v-chip
                v-if="item?.assistant?.society"
                small
                :color="getHashColor(item.assistant.society)"
                text-color="white"
              >
                {{ item.assistant.society }}
              </v-chip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import Student from "@/models/Student"
import Assistant from "@/models/Assistant"
import StudentForm from "@/components/students/StudentForm.vue"
import { mapGetters } from "vuex"
import { getCourseTypeColor, getCourseTypeLabel, getCourseTypeAbbr, getHashColor } from "@/utils/helpers"

export default {
  components: {
    StudentForm,
  },
  data() {
    return {
      loading: true,
      search: "",
      headers: [
        { text: "Nom Prénom", value: "displayName", align: "left" },
        { text: "Cours", value: "courseName" },
        { text: "Type", value: "courseType" },
        { text: "Assistant social", value: "assistant.name" },
        { text: "Envoyé par ", value: "assistant.society" },
      ],
      pagination: {},
      query: "",
      dialog: false,
      isShowAllStudents: false,
    }
  },
  async mounted() {
    await Assistant.get()
    await Student.get()
    this.loading = false
  },
  computed: {
    ...mapGetters("Auth", ["isAdmin"]),
    students() {
      return Student.query().with("assistant").all()
    },
    filteredStudents() {
      const list = this.isShowAllStudents ? this.students : this.students.filter((s) => s.is_active)
      return list.map((s) => ({
        ...s,
        displayName: s.displayName,
        courseName: s.courses?.[0]?.name || "",
        courseType: getCourseTypeLabel(s.courses?.[0]?.type),
      }))
    },
  },
  methods: {
    navigateToStudent(student) {
      this.$router.push(`/students/${student.id}`)
    },
    getCourseTypeColor,
    getCourseTypeLabel,
    getCourseTypeAbbr,
    getHashColor,
  },
}
</script>
<style scoped>
.clickable {
  cursor: pointer;
}
</style>
